<div>
    <div class="repeat-container" *ngFor="let bg of backgrounds">
        <app-single-background-legend *ngIf="bg.visible || showDevElements" [legend]="bg"></app-single-background-legend>
    </div>
</div>
